/** Map technical / chain errors to calm user-facing Russian copy. */
export function friendlyError(raw: unknown, fallback = "Не удалось выполнить действие — попробуйте ещё раз"): string {
  const msg = raw instanceof Error ? raw.message : String(raw ?? "");
  if (!msg) return fallback;

  if (/Aborted/i.test(msg)) return "";
  if (/Сеть обновляется|попробуйте через минуту/i.test(msg)) return msg;
  if (/Подключите кошелёк|Выберите пару/i.test(msg)) return msg;

  if (/create_token|get_token_info|Connection timeout|Token expired|Not connected|No token/i.test(msg)) {
    return "Не удалось подключить кошелёк — откройте Axiome Wallet и попробуйте снова";
  }
  if (/sign failed/i.test(msg)) {
    return "Подпись не прошла — проверьте кошелёк и повторите";
  }
  if (/query failed|indexer|balance query|fetch|Failed to fetch|NetworkError|network/i.test(msg)) {
    return "Сеть обновляется — попробуйте через минуту";
  }
  if (/inventory|caps|pause|can_provide|Provide сейчас/i.test(msg)) {
    return "Сейчас внесение временно недоступно — попробуйте позже или другую сумму";
  }
  if (/preview_withdraw|min_axm|вывод заблокирован|migration/i.test(msg)) {
    return "Вывод временно недоступен — попробуйте через минуту";
  }
  if (/HarvestRequired|harvest required/i.test(msg)) {
    return "Сначала нужно обновить доходность рынка — повторите через несколько секунд";
  }
  if (/HarvestTooSoon|too soon|Load Failed|load failed/i.test(msg)) {
    return "Кошелёк не смог загрузить транзакцию — подождите минуту и повторите";
  }
  if (/insufficient|balance|funds|allowance|TokenInsolvent/i.test(msg)) {
    return "Недостаточно средств или разрешения в кошельке";
  }
  if (/paused|inactive|not found|unknown market|MarketMustExist/i.test(msg)) {
    return "Этот рынок сейчас недоступен";
  }
  if (/slippage|LP too small|minLp|maxToken|minAxm/i.test(msg)) {
    return "Сумма слишком мала или рынок изменился — попробуйте другую сумму";
  }
  if (/user rejected|denied|cancel/i.test(msg)) {
    return "Действие отменено в кошельке";
  }

  // Hide raw English / stack-like noise
  if (/^[A-Za-z0-9_.:\s\-/{}"[\]]+$/.test(msg) && /failed|error|undefined|null|0x/i.test(msg)) {
    return fallback;
  }

  return msg.length > 160 ? fallback : msg;
}
